import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { Subject, debounceTime, switchMap } from 'rxjs';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-groups',
  standalone: true,
  imports: [
    MatTableModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
  ],
  templateUrl: './groups.component.html',
  styleUrl: './groups.component.css',
})
export class GroupsComponent implements OnInit {
  @Input() tabSelected: boolean = false;
  newGroupName: string = '';
  displayedColumns: string[] = ['name', 'actions'];
  dataSource = new MatTableDataSource();
  filterValue: string = '';
  currentPage = 1;

  private filterSubject = new Subject<string>();

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.filterSubject
      .pipe(
        debounceTime(300), // Debounce time in ms
        switchMap((filterValue) => {
          let filters: any = {};
          return this.apiService.getGroups(this.currentPage, filters); // API call with filters
        })
      )
      .subscribe((data) => {
        this.dataSource = new MatTableDataSource(data); // Update table data
      });

    this.filterSubject.next(this.filterValue);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabSelected'] && changes['tabSelected'].currentValue) {
      this.filterSubject.next(this.filterValue);
    }
  }

  onDeleteClick(name: string) {
    const isConfirmed = window.confirm(`Vuoi eliminare il gruppo ${name}?`);
    if (!isConfirmed) {
      return;
    }
    this.apiService.deleteGroup(name).subscribe((data) => {
      console.log('Gruppo eliminato:', name);
      this.filterSubject.next(this.filterValue);
    });
  }

  onSubmit(): void {
    if (this.newGroupName) {
      this.apiService.createGroup(this.newGroupName).subscribe((data) => {
        console.log('Nuovo gruppo creato:', this.newGroupName);
        this.newGroupName = '';
        this.filterSubject.next(this.filterValue);
      });
    } else {
      console.log('Inserisci un nome per il gruppo.');
    }
  }
}
